import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAccessToken } from "../../contexts/AccessTokenContext";

const Success = () => {
  const { accessToken } = useAccessToken();
  const { isLoading } = auth || {};
  const navigate = useNavigate();

  // const auth = useAuth()

  useEffect(() => {
    if (!isLoading && auth.userData) {
      // redirect to home page
      navigate("/company");
      return;
    }

    return () => {};
  }, [auth, navigate, isLoading]);

  return (
    <div>
      <h1>Callback Success</h1>
    </div>
  );
};

export default Success;
